/**
 * spotlightEvents — thin fire-and-forget wrapper around
 * POST /api/spotlight-events for Featured-Slot funnel tracking.
 *
 * Never throws. Never awaits at call sites. Perfectly safe to sprinkle
 * across click handlers without wrapping in try/catch.
 */
import { api } from "@/lib/api";

// Deduplicate impressions within a session so we don't spam the endpoint
// each time a TierLock re-renders on the SEO tab.
const _seen = new Set();

/**
 * @param {string} event  — one of featured_lock_impression |
 *                           featured_lock_click | boost_button_click |
 *                           pricing_spotlight_view | pricing_spotlight_cta
 * @param {Object} [meta] — {campaign_id, plan_key, source, session_id}
 * @param {Object} [opts] — {dedupe: true} to fire once per session per key
 */
export function trackSpotlightEvent(event, meta = {}, opts = {}) {
    try {
        if (opts.dedupe) {
            const key = `${event}::${meta.campaign_id || ""}::${meta.source || ""}`;
            if (_seen.has(key)) return;
            _seen.add(key);
        }
        // Fire-and-forget: don't await, don't surface errors — this must
        // never block or affect UX. Failed events silently drop.
        api.post("/spotlight-events", { event, ...meta }).catch(() => { });
    } catch {
        /* noop */
    }
}
